export const ADD_USER = Symbol('ADD_USER');

export const addUserAction = (user) => ({
  type: ADD_USER,
  payload: user,
});
